export default "__VITE_ASSET__BxSZ7par__"